export default {
  error: false,
  permissions: [],
  groupId: undefined,
  groupPermissionsDb: [],
  groupPermissions: [],
  modal: false,
  newGroupName: '',
  unsavedChanges: false,
  groupName: '',
  editGroupNameError: '',
};
